import React, { useEffect, useState } from 'react';
import { Row, Col } from "react-bootstrap";
import { CustomCard } from "../../components/Card/CustomCard";

import EditBanner from './Inicio/EditBanner';

const EditInicio = () => {
    
    
    let contenido = () => {
        return (
            <EditBanner />
        )
    }

    let ayuda = () => {

    }

    return (
        <div className="content">
            <Row>
                <Col md={8}>
                    <div style={{borderRadius: "4px 4px"}}>
                        <CustomCard
                            title= "Editar Contenido de Inicio"
                            category=""
                            color="#a80012"
                            content={contenido()}
                        />
                    </div>
                </Col>
                <Col md={4}>
                    <div style={{borderRadius: "4px 4px",}}>
                        <CustomCard
                            styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                            title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                            category={<span style={{color: "#fff"}}>Editar Inicio</span>}
                            color="#a80012"
                            content={ayuda()}
                        />
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default EditInicio;


// WEBPACK FOOTER //
// ./src/views/WebMaster/EditInicio.jsx